import React, {
  useEffect,
  useImperativeHandle,
  forwardRef,
  useCallback,
} from "react";
import { createPortal } from "react-dom";

const Modal = ({ children, fade = false, isOpen, setIsOpen }, ref) => {
  const close = useCallback(() => setIsOpen(false), []);

  useImperativeHandle(
    ref,
    () => ({
      open: () => setIsOpen(true),
      close,
    }),
    [close]
  );

  const handleEscape = useCallback(
    (event) => {
      if (event.keyCode === 27) close();
    },
    [close]
  );

  useEffect(() => {
    if (isOpen) document.addEventListener("keydown", handleEscape, false);

    return () => {
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [handleEscape, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isOpen]);

  // 닫기 버튼을 클릭할 때 모달을 닫도록 처리
  const handleCloseButtonClick = () => {
    close();
  };

  const popoverStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10000,
  };

  const popoveroverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(0, 0, 0, 0.5)",
  };

  const popoverChildStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10000,
  };

  return createPortal(
    isOpen ? (
      <div className="ly_popover" style={popoverStyle}>
        <div
          className="ly_popover-overlay"
          style={popoveroverlayStyle}
          onClick={close}
        />
        <div style={popoverChildStyle}>
          {React.cloneElement(children, {
            handleCloseButtonClick: handleCloseButtonClick,
          })}
        </div>
      </div>
    ) : null,
    document.getElementById("modal_root")
  );
};

export default forwardRef(Modal);
